import * as yup from "yup"; // <-- Add this import

export const downloadReportvalidationSchema = yup.object().shape({
  email: yup.string().email("Invalid email").when("schedule", {
    is: true,
    then: (schema) => schema.required("Email is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  startDate: yup.string().required("Start date is required"),
  endDate: yup
    .string()
    .required("End date is required")
    .test("is-after", "End date cannot be before start date", function (value) {
      const { startDate } = this.parent;
      return !startDate || !value || value >= startDate;
    }),
  schedule: yup.boolean(),
  scheduleDate: yup.string().when("schedule", {
    is: true,
    then: (schema) =>
      schema
        .required("Schedule date is required")
        .test(
          "is-future",
          "Schedule date must be in the future",
          function (value) {
            if (!value) return true;
            const today = new Date().toISOString().split("T")[0];
            return value >= today;
          }
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
  scheduleTime: yup.string().when("schedule", {
    is: true,
    then: (schema) =>
      schema
        .required("Schedule time is required")
        .test("is-valid-time", "Invalid time format (use HH:mm)", (value) =>
          /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)
        )
        .test(
          "is-future-time",
          "Scheduled time must be in the future",
          function (value) {
            if (!value || !this.parent.scheduleDate) return true;

            const now = new Date();
            const today = now.toISOString().split("T")[0];
            const currentTime = now.toTimeString().substring(0, 5);

            // If scheduled date is today, check if time is in future
            if (this.parent.scheduleDate === today) {
              return value > currentTime;
            }
            return true;
          }
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
  recurrence: yup.string().when("schedule", {
    is: true,
    then: (schema) => schema.required("Recurrence is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
